import { forwardRef, useCallback, useEffect, useState } from "react";
import { Box, TextField, Drawer, Typography, InputAdornment, IconButton, Button } from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch } from "react-redux";
import { getUsersAllData } from "../../../../actions/usersAllData";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { setUserCashback } from "../../../../services/vendor/vendor.service";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const CashbackDrawer = ({ open, onClose, item, setUpdData }) => {

    const [value, setValue] = useState(0);
    const handleIncrease = () => setValue((prev) => prev + 1);
    const handleDecrease = () => setValue((prev) => (prev > 0 ? prev - 1 : 0));

    // hooks
    const dispatch = useDispatch();

    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success", // can be 'error' | 'success' | 'warning' | 'info'
    });


    // Api calls for get Order
    const getData = useCallback(
        async (id, orders) => {
            const res = await dispatch(getUsersAllData(item?._id, "cashback"));
            setData(res?.data?.data);
            setloading(false);
        },
        [dispatch]
    );

    useEffect(() => {
        getData()
    }, [open, item?._id]);



    const calculateTotalCost = (item) => {
        if (!item) return 0;
        const price = Number(item?.itemPrice) || 0;
        const quantity = Number(item?.quantity) || 0;
        const tax = Number(item?.itemTax) || 0;
        const shippingCost = Number(item?.shippingFee) || 0;

        return (price * quantity) + tax + shippingCost;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await setUserCashback(item?._id, value);
            console.log("resssss===", res);
            setValue(value);
            setData(res?.data);
            setSnackbar({
                open: true,
                message: res?.message || "Cashback updated successfully.",
                severity: "success",
            });

        } catch (error) {
            console.error("Error updating user details:", error);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || "Failed to update cashback.",
                severity: "error",
            });
        }
    };



    return (
        <>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 1, p: 1 }}>
                        <Typography
                            className="sofiaRegular"
                            color="#222020"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px" }}
                        >
                            Cashback
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#1b1919" }}
                        >
                            {item?.email}
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <form onSubmit={handleSubmit}>
                    <Box
                        sx={{
                            mt: 5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid #ddd",
                            borderRadius: 2,
                            padding: "14px 5px",
                            bgcolor: "white",
                        }}
                    >
                        {/* Label */}
                        <Typography
                            className="sofiaRegular"
                            sx={{ fontWeight: "bold", fontSize: 16 }}>
                            Cashback Account Balance
                        </Typography>

                        {/* Input with vertical stepper buttons */}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <TextField
                                variant="outlined"
                                className="sofiaRegular"
                                value={value}
                                onChange={(e) => {
                                    const input = e.target.value;

                                    // Allow only numbers — no letters, symbols, etc.
                                    const onlyNumbers = input.replace(/[^0-9]/g, "");

                                    // Convert to number or default to 0
                                    const numericValue = Number(onlyNumbers);
                                    setValue(isNaN(numericValue) ? 0 : numericValue);
                                }}
                                inputProps={{
                                    inputMode: "numeric", // mobile keyboard for numbers
                                    style: {
                                        width: 80,
                                        textAlign: "right",
                                        fontWeight: "bold",
                                        padding: "8px 9px 8px 0px",
                                        backgroundColor: "#fafafa",
                                    },
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "6px",
                                        fontWeight: "bold",
                                        "& input": { textAlign: "center" },
                                    },
                                }}
                            />


                            {/* Vertical Stepper Buttons */}
                            <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
                                <IconButton
                                    size="small"
                                    sx={{
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        bgcolor: "#e1e5e8",
                                        mb: 0.5,
                                        padding: "0 !important",
                                        "&:hover": { bgcolor: "#e0e0e0" },
                                    }}
                                    onClick={handleIncrease}
                                >
                                    <KeyboardArrowUpIcon color="#101010" sx={{ fontSize: "14px" }} />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    sx={{
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        bgcolor: "#e1e5e8",
                                        padding: "0 !important",
                                        "&:hover": { bgcolor: "#e0e0e0" },
                                    }}
                                    onClick={handleDecrease}
                                >
                                    <KeyboardArrowDownIcon color="#101010" sx={{ fontSize: "14px" }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                    {/* Update Application Status Button */}
                    <Button
                        type="submit"
                        className="sofiaRegular"
                        fullWidth
                        variant="contained"
                        sx={{
                            mt: 2,
                            bgcolor: "#000",
                            color: "#fff",
                            fontWeight: "bold",
                            p: "12px !important",
                            textTransform: "none",
                            borderRadius: "8px",
                            border: "1px solid #090909",
                            "&:hover": { bgcolor: "#222" },
                        }}
                    >
                        Save account balance
                    </Button>

                </form>
                <Box sx={{ mt: 4 }}>
                    <Typography
                        className="sofiaRegular"
                        sx={{ fontWeight: "bold", fontSize: 18, mb: 3 }}>
                        Cashback History:
                    </Typography>

                    {Data?.length > 0 ? (Data?.map((item) => (
                        <Box
                            key={item.id}
                            sx={{
                                mt: 3,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderRadius: 2,
                                p: "10px 9px",
                                mb: 2,
                                bgcolor: "#fff",
                                border: "1px solid #c5c5c5"
                            }}
                        >
                            <Box>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontWeight: "bold", fontSize: 16, color: "#000" }}>
                                    {item?.itemOrderNumber} | Order total: ${calculateTotalCost(item).toFixed(2)}
                                </Typography>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 14, color: "#000" }}
                                >
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color:
                                                item?.status === "paid"
                                                    ? "green"
                                                    : item?.status === "pending"
                                                        ? "#f39c12" // golden-orange
                                                        : item?.status === "return"
                                                            ? "#e74c3c" // red
                                                            : "#555",
                                            textTransform: "capitalize",
                                        }}
                                    >
                                        {item?.status === "return" ? "Cancel" : item?.status}
                                    </span>{" "}
                                    | {item?.formattedDate}
                                </Typography>

                            </Box>

                            <Box sx={{ textAlign: "right" }}>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 16, fontWeight: "bold", color: "#272727" }}>
                                    +${item?.cashBack.toFixed(2)}
                                </Typography>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 16, fontWeight: "bold", color: "#272727" }}>
                                    {item?.usedCashBack ? `-$${item.usedCashBack.toFixed(2)}` : "-$0.00"}
                                </Typography>
                            </Box>
                        </Box>
                    ))
                    ) : (
                        <Typography className="sofiaRegular" sx={{ color: "#000", textAlign: "center", mt: 2 }}>
                            No Data found.
                        </Typography>
                    )}
                </Box>


            </Drawer>
        </>
    )
}

export default CashbackDrawer
